import { render, staticRenderFns } from "./DragCarousel.vue?vue&type=template&id=695b4f97&scoped=true&"
import script from "./DragCarousel.vue?vue&type=script&lang=js&"
export * from "./DragCarousel.vue?vue&type=script&lang=js&"
import style0 from "./DragCarousel.vue?vue&type=style&index=0&id=695b4f97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b4f97",
  null
  
)

export default component.exports